<div  class="field ">
    <div class="rowLabel">
        <label class="columnLabel" for="{{id}}" class="block">{{label|translate}}  :</label>
        <p *ngIf = "isRequired" class="columnLabel">{{"LABEL.REQURID"|translate}}</p>
    </div>
    <div  *ngIf="imagesList?.length>0"  class="row contain">
            <div *ngFor="let it of imagesList" >
                <div  class="contain-item">
                    <i *ngIf="!view" class='bx bxs-message-square-x remove' (click) = removeImage(it) ></i>

                    <img  class="column item"   [src]="getImageUrl(it.imageUrl)">
                    <!-- <div class="column item"> -->
                    <!-- </div> -->
                </div>


            </div>
    </div>
</div>
<div  *ngIf="!view" class="field ">
    <div class="select-image-btn">
        <input multiple="multiple" (change)="myUploader($event)"  type="file" accept="image/*" id="selectedFile" style="display: none;" />
        <m-button
        setClassName="uploadBtn"
        setLabel="LABEL.ADD_IMAGE"
        onClick="document.getElementById('selectedFile').click();"
        >
          </m-button>
    </div>

<!-- <input type="button" value="Browse..." onclick="document.getElementById('selectedFile').click();" /> -->
    <div *ngIf="selected"   class="row contain">
            <div *ngFor="let en of urlList" >
                <div  class="contain-item">
                    <i class='bx bxs-message-square-x remove'(click) = removeImageSelect(en) ></i>

                    <img  class="column item"   [src]="en">
                    <!-- <div class="column item"> -->
                    <!-- </div> -->
                </div>


            </div>
    </div>
</div>